<template>
  <DashboardView />
</template>

<script lang="ts" setup>
  import DashboardView from './DashboardView.vue'
  import labels from '@/translations/labels.json'
  import { useRoute, useRouter } from 'vue-router'
  import { useDashboardStore } from '@/stores/dashboardStore'
  import { onMounted, watch } from 'vue'

  const route = useRoute()
  const router = useRouter()
  const dashboardStore = useDashboardStore()

  function routeChanged(dashboardId: string | string[]) {
    if (route.name === labels.SIDEBAR.MAIN.DASHBOARD) {
      if (typeof dashboardId === 'string' && !isNaN(parseInt(dashboardId))) {
        dashboardStore.selectedDashboardId = parseInt(dashboardId)
      } else {
        router.push({
          name: labels.SIDEBAR.MAIN.DASHBOARD,
          params: {
            ...route.params,
            dashboardId: 0,
          },
        })
      }
    }
  }

  watch(() => route.params.dashboardId, routeChanged)

  onMounted(async () => {
    routeChanged(route.params.dashboardId)
  })
</script>
